// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.dropzone label {
  color: #1F2937 !important;
}
.dropzone label u {
  text-decoration: underline;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.close-button {
  color: black;
  border: 1px solid black;
  background-color: white;
  gap: 24px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ECF0F5;
  gap: 24px;
}

.p-button.button-sm {
  font-size: 12px;
  padding: 10px 12px;
  width: auto;
  height: 32px;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.gc-agency-name {
  color: #2d388b;
}

.eSockFiles table {
  padding: 0;
}
.eSockFiles table th {
  background-color: #f6f8ff;
  padding: 10px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  color: #1F2937;
}
.eSockFiles table td {
  border-bottom: 1px solid #e9ecef;
  text-align: left;
  padding: 10px 20px;
  overflow-wrap: anywhere;
  font-size: 14px;
  color: #1F2937;
}
.eSockFiles table tr:last-child td {
  border: none;
}

.w-165 {
  width: 165px !important;
}

.align-expand-text {
  text-align: center;
  color: #2d388b;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}

.multi-entry-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.multi-entry-row .flex-grow-1 {
  flex: 1;
  min-width: 0;
}

.btn-remove-entry {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  flex-shrink: 0;
}

.btn-add-entry {
  padding: 4px 0 !important;
  font-size: 13px;
  height: auto !important;
  width: auto !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  color: #6B7280 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
